import styled from "styled-components";

export const NavbarDiv = styled.nav`
  background-color: #fff;

  .wrapper {
    display: flex;
    padding: 0.93rem 1.5rem;
    justify-content: space-between;
    min-height: 62px;

    .header {
      display: flex;
      align-items: center;
    }

    ul {
      display: flex;
      list-style: none;
      gap: 1rem;

      li {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0 0.5rem;

        color: #555;
      }
    }
  }
  hr {
    height: 0;
    border: 0.5px solid lightgray;
  }
`;
